/** @format */

// vendor
import { defineComponent, ref, reactive, computed, provide } from "@vue/composition-api";
// project
import * as StudyAPI from "@/services/api/studies";
import * as AssetAPI from "@/services/api/assets";
import { Asset, Study, AssetVersion, StudyDataChannel } from "@psychlab/types";
import { StudyContext } from "./StudyContext";
import { ContextHeader } from "@/components.nav/context-header";
import { Studyheader, StudyNavigation } from "./header";
import { AbsBox } from "@ui";

export type EditState = {
	editing: boolean;
	value: string;
};

export const ManageStudy = defineComponent({
	components: {
		AbsBox,
		StudyNavigation,
		ContextHeader,
		Studyheader,
	},
	setup(_, context) {

		const studyId = computed(() => {
			const r = context.root.$route;
			return r.params["studyId"] || r.params["groupId"];
		});

		const blueprint = ref<Asset>();
		const blueprintVersion = ref<AssetVersion<any>>();
		const study = ref<Study>();
		const editingName = reactive<EditState>({
			editing: false,
			value: "",
		});

		const channels = ref<StudyDataChannel[]>([]);

		const studyContext = computed<StudyContext>(() => ({
			study,
			channels,
			blueprint,
			blueprintVersion,
		}));

		provide("study", study);
		provide("studyContext", studyContext);

		const init = async () => {
			if(!studyId.value){ return; }
			
			try {
				study.value = await StudyAPI.getStudy(studyId.value);

				editingName.value = study.value.name;

				blueprint.value = await AssetAPI.getAsset(
					study.value.target.study,
				);
				blueprintVersion.value = await AssetAPI.getAssetVersion(
					study.value.target.study,
					study.value.target.version,
					"+data +vIndex +name"
				);
				channels.value = await StudyAPI.getStudyDataChannels(studyId.value);
			}
			catch(err){
				console.log(err.message);
			}
		};

		init();

		return {
			study,
			studyId,
		};
	},
});
